export default __webpack_public_path__ + "static/media/total.e90c2d1e.svg";